import React from 'react';
import { DeviceIconProps, getSizeInPixels } from '../types';

/**
 * ERV Icon Style02 - Heat Exchange icon
 * 熱交換圖示 - 雙向箭頭表示熱交換
 */
export const Style02_Ventilation: React.FC<DeviceIconProps> = ({ 
  isOn = false, 
  size = 'small',
  className = '',
  animated = false 
}) => {
  const sizeInPx = getSizeInPixels(size);
  const primaryColor = isOn ? '#2dd4bf' : '#64748b'; // teal-400 : slate-500
  const warmColor = isOn ? '#fb923c' : '#64748b'; // orange-400 : slate-500
  const coolColor = isOn ? '#38bdf8' : '#64748b'; // sky-400 : slate-500
  
  return (
    <svg
      viewBox="0 0 24 24"
      width={sizeInPx}
      height={sizeInPx}
      fill="none"
      className={`${className} ${animated && isOn ? 'animate-pulse' : ''}`}
    >
      {/* Center rectangle (heat exchanger core) */}
      <rect
        x="8"
        y="6"
        width="8"
        height="12"
        rx="2"
        stroke={primaryColor}
        strokeWidth="1.5"
        fill="none"
      />
      
      {/* Warm air arrow (left to right, top) */}
      <path
        d="M2 8L6 8M6 8L4 6M6 8L4 10"
        stroke={warmColor}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18 8L22 8"
        stroke={warmColor}
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      
      {/* Cool air arrow (right to left, bottom) */}
      <path
        d="M22 16L18 16M18 16L20 14M18 16L20 18"
        stroke={coolColor}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6 16L2 16"
        stroke={coolColor}
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      
      {/* Heat exchange lines inside */}
      <line x1="10" y1="9" x2="14" y2="9" stroke={primaryColor} strokeWidth="1" opacity="0.5" />
      <line x1="10" y1="12" x2="14" y2="12" stroke={primaryColor} strokeWidth="1" opacity="0.5" />
      <line x1="10" y1="15" x2="14" y2="15" stroke={primaryColor} strokeWidth="1" opacity="0.5" />
    </svg>
  );
};

export default Style02_Ventilation;
